/**
 * Truncate a string
 *
 * @param {string} str
 * @param {number} length
 * @param {string} ending
 */
export function textTruncate(str, length = 100, ending = '...') {
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  }

  return str;
}
